import { supabase } from "./supabaseClient";

export const storeChatHistory = async (
  sessionId,
  content,
  type,
  isQuery,
  path = null,
  queue_id = null,
  user_id = null
) => {
  try {
    const { data, error } = await supabase
      .from("chat")
      .insert(
        isQuery
          ? [
              {
                chat_session_id: sessionId,
                content: content,
                type: type,
                is_query: isQuery,
                path: path,
                queue_id: queue_id,
                user_id: user_id, // Add user_id here

              },
            ]
          : [
              {
                chat_session_id: sessionId,
                content: content,
                type: type,
                is_query: isQuery,
                path: path,
                user_id: user_id, // Add user_id here
              },
            ]
      )
      .select("id");

    if (error) {
      console.error("Error storing chat history:", error);
      throw error;
    }
    return data;
  } catch (error) {
    console.error("Error storing chat history:", error);
    throw error;
  }
};

export const storeQueueHistory = async (
  sessionId,
  title,
  userQuery,
  details,
  user_id = null
) => {
  try {
    const { data, error } = await supabase
      .from("queue_request")
      .insert(
        [
          {
            session_id: sessionId,
            title: title,
            details: details,
            user_id: user_id,
          }
        ]
      )
      .select("*");

        if (error) {
      console.error("Error storing queue request:", error);
      throw error;
    }

    // Add null check before accessing data[0]
    if (!data || data.length === 0) {
      throw new Error("Queue request creation failed - no data returned");
    }

      // insert queue chat
      const { data: dataChat, error: errorChat } =  await supabase
      .from("queue_chat")
      .insert(
        [
          {
            queue_request_id: data[0].id,
            user_query: userQuery,
            user_id: user_id // Add user_id here
          }
        ]
      )
      .select("*");
      console.log("Queue data:", dataChat);

    if (error) {
      console.error("Error storing chat history:", error);
      throw error;
    }
    return { dataQueue: data, chatQuery: dataChat };
  } catch (error) {
    console.error("Error storing chat history:", error);
    throw error;
  }
};

export const storeQueueChat = async (
  sessionId,
  userQuery,
  audioUrl = null,
  user_id = null
) => {

  const { data, error } = await supabase
  .from("queue_request")
  .update({ completed: false, is_view: false})
  .eq("id", sessionId)  // Replace recordId with the actual ID you want to update
  .select("id");
  if (error) {
    console.error("Error updating queue request:", error);
    throw error;
  }

  const insertData = {
    queue_request_id: sessionId,
    user_query: userQuery,
    user_id: user_id // Add user_id here
  };

  // Only add path if audioUrl exists
  if (audioUrl) {
    insertData.path = audioUrl; // Using 'path' column for audio URL
  }

  const { data: dataChat, error: errorChat } =  await supabase
    .from("queue_chat")
    .insert([insertData])
    .select("id");

  if (errorChat) {
    console.error("Error storing queue chat:", errorChat);
    throw errorChat;
  }

  return dataChat;
}


export const storeMeetingChat = async (
  sessionId,
  userQuery,
  audioUrl = null,
  user_id = null
) => {
  try {
    const insertData = {
      meeting_summaries_id: sessionId,
      user_query: userQuery,
      user_id: user_id // Add user_id here
    };

    // Only add path if audioUrl exists
    if (audioUrl) {
      insertData.path = audioUrl; // Using 'path' column for audio URL
    }

    const { data, error } = await supabase
      .from("meeting_summaries_chat")
      .insert([insertData])
      .select("id");

    if (error) {
      console.error("Error storing meeting chat:", error);
      throw error;
    }
    return data;
  } catch (error) {
    console.error("Error in storeMeetingChat:", error);
    throw error;
  }
}

// Store first response in meeting chat - only if no entry exists
export const storeMeetingChatFirstResponse = async (
  meetingId,
  meetingData,
  user_id = null
) => {
  try {
    // Step 1: Check if any entry exists for this meeting
    const { data: existingChat, error: checkError } = await supabase
      .from("meeting_summaries_chat")
      .select("id")
      .eq("meeting_summaries_id", meetingId)
      .limit(1);

    if (checkError) {
      console.error("Error checking meeting chat:", checkError);
      throw checkError;
    }

    // Step 2: If entry exists, return null (don't store)
    if (existingChat && existingChat.length > 0) {
      console.log("Meeting chat already exists, skipping first response storage");
      return null;
    }

    // Step 3: No entry exists, format and store the first response
    // Format with proper HTML tags - only Meeting Title, Meeting Date, Short Summary
    const formattedResponse = `<h4>Meeting Title</h4>
<p>${meetingData?.meeting_title || "N/A"}</p>
<br/>
<h4>Meeting Date</h4>
<p>${meetingData?.meeting_date || "N/A"}</p>
<br/>
<h4>Short Summary</h4>
<p>${meetingData?.short_summary || "N/A"}</p>`;

    const insertData = {
      meeting_summaries_id: meetingId,
      user_query: "",  // Keep user_query blank
      response: formattedResponse,  // Store formatted response
      user_id: user_id
    };

    const { data, error } = await supabase
      .from("meeting_summaries_chat")
      .insert([insertData])
      .select("id");

    if (error) {
      console.error("Error storing meeting chat first response:", error);
      throw error;
    }

    console.log("First response stored successfully:", data);
    return data;
  } catch (error) {
    console.error("Error in storeMeetingChatFirstResponse:", error);
    throw error;
  }
}

export const storeNotificationChat = async (
  sessionId,
  userQuery,
  audioUrl = null,
  user_id = null
) => {
  try {
    const insertData = {
      notification_id: sessionId,
      user_query: userQuery,
      user_id: user_id // Add user_id here
    };

    // Only add audio_url if it exists and the column is available
    if (audioUrl) {
      insertData.path = audioUrl; // Using 'path' column instead of 'audio_url'
    }

    const { data: dataChat, error: errorChat } = await supabase
      .from("notification_chat")
      .insert([insertData])
      .select("id");

    if (errorChat) {
      console.error("Error storing notification chat:", errorChat);
      throw errorChat;
    }

    return dataChat;
  } catch (error) {
    console.error("Error in storeNotificationChat:", error);
    throw error;
  }
}

export const isViewQueue = async (
  sessionId
) => {
  const { data:dataChat, error:dataError } = await supabase
  .from("queue_chat")
  .select("id, queue_request_id, response, created_at")
  .eq("queue_request_id", sessionId)  // Replace with your actual queue_request_id variable
  .order("created_at", { ascending: false })
  .order("id", { ascending: false })
  .limit(1)
  .single();  // Use single() if you expect exactly one result

  // Check if response is null
  const isResponseNull = !dataChat || dataChat.response === null;


  if(!isResponseNull){

    const { data, error } = await supabase
    .from("queue_request")
    .update({ is_view: true})
    .eq("id", sessionId)  // Replace recordId with the actual ID you want to update
    .select("id");
    if (error) {
      console.error("Error updating queue request:", error);
      throw error;
    }
    return data;
  }
  return  dataChat
}



export const clearChatHistory = async (sessionId) => {
  try {
    const { data, error } = await supabase
      .from("chat")
      .update({
        is_delete: true,
      })
      .eq("chat_session_id", sessionId); // Update the record where chat_session_id matches sessionId

    if (error) {
      throw error;
    }
    // await storeChatHistory(
    //   sessionId,
    //   "Hi! 👋 How can I help you today?",
    //   "text",
    //   false
    // );
    return true;
  } catch (error) {
    console.error("Error updating record:", error);
  }
};
export const getChatHistoy = async (sessionId, page, pageSize) => {
  try {
    const start = (page - 1) * pageSize;
    const end = start + pageSize - 1;
    let {
      data: chat,
      count,
      error,
    } = await supabase
      .from("chat")
      .select("*")
      .eq("chat_session_id", sessionId)
      .eq("is_delete", false)
      .or('type.neq.text, and(type.eq.text, content.neq."")')
      .order("created_at", { ascending: false })
      .range(start, end);

    if (error) {
      console.error("Error storing chat history:", error);
      throw error;
    }
    return chat;
  } catch (error) {
    console.error("Error fetching chat history:", error);
    throw error;
  }
};

export const checkPreviousSession = async (userId) => {
  try {
    let { data: chat_session, error: sessionError } = await supabase
      .from("chat_session")
      .select("id")
      .eq("user_auth", userId);

    // Handle errors during chat session fetch
    if (sessionError) {
      console.error("Error getting previous chat session:", sessionError);
      throw sessionError;
    }
    if (chat_session.length) {
      return chat_session;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error fetching chat session:", error);
    throw error;
  }
};

export const removeSessionandChatHistory = async (sessionId, userId) => {
  try {
    const { error: chatError } = await supabase
      .from("chat")
      .delete()
      .eq("chat_session_id", sessionId);

    if (!chatError) {
      const { error: sessionError } = await supabase
        .from("chat_session")
        .delete()
        .eq("id", sessionId);
      if (!sessionError) {
        var files = [];
        let getFileDetails = async (type) => {
          const { data, error } = await supabase.storage
            .from("Storage")
            .list(`${userId}/${sessionId}/${type}`);
          data.forEach((element) => {
            files.push(`${userId}/${sessionId}/${type}/${element.name}`);
          });
        };
        let deleteFiles = async (files) => {
          const { data, error } = await supabase.storage
            .from("Storage")
            .remove(files);
          if (data) {
            return true;
          } else {
            return false;
          }
        };
        await getFileDetails("images");
        await getFileDetails("audios");
        await getFileDetails("pdfs");
        let deleteDone = await deleteFiles(files);
        if (deleteDone) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};

// export const uploadFileAndGetUrl = async (sessionId, userId, selectedFile) => {
//   try {
//     const fileType = selectedFile.type.startsWith('image/')
//       ? 'images'
//       : 'pdfs'
//     const filePath = `${userId}/${sessionId}/${fileType}/${selectedFile.name}`

//     // Check if the folder exists, if not, create it
//     const { data: folderData, error: folderError } =
//       await supabase.storage.from('Storage').list(userId)
//     await supabase.storage.from('Storage').list(userId / sessionId)

//     if (
//       folderError &&
//       folderError.message.includes('The resource was not found')
//     ) {
//       await supabase.storage.from('Storage').createFolder(userId)
//       await supabase.storage.from('Storage').createFolder(sessionId)
//       await supabase.storage
//         .from('Storage')
//         .createFolder(`${userId}/${sessionId}/images`)
//       await supabase.storage
//         .from('Storage')
//         .createFolder(`${userId}/${sessionId}/pdfs`)
//     }

//     // Upload the file
//     const { error: uploadError } = await supabase.storage
//       .from('Storage')
//       .upload(filePath, selectedFile)

//     if (uploadError) {
//       throw uploadError
//     }

//     const { data } = supabase.storage
//       .from('Storage')
//       .getPublicUrl(filePath)

//     if (data) {
//       return data.publicUrl
//     }

//   } catch (error) {
//     console.error('Error uploading file:', error)
//   }
// }

export const uploadFileAndGetUrl = async (sessionId, userId, selectedFile) => {
  try {
    const fileType = selectedFile.type.startsWith("image/") ? "images" : "documents";
    // PATCH: Make file name unique
    const ext = selectedFile.name.split(".").pop();
    const baseName = selectedFile.name.replace(/\.[^/.]+$/, "");
    const uniqueFileName = `${baseName}_${Date.now()}.${ext}`;
    const filePath = `${userId}/${sessionId}/${fileType}/${uniqueFileName}`;

    // Check if the folder exists, if not, create it
    const { data: folderData, error: folderError } = await supabase.storage
      .from("Storage")
      .list(userId);
    await supabase.storage.from("Storage").list(`${userId}/${sessionId}`);

    if (
      folderError &&
      folderError.message.includes("The resource was not found")
    ) {
      await supabase.storage.from("Storage").createFolder(userId);
      await supabase.storage.from("Storage").createFolder(sessionId);
      await supabase.storage
        .from("Storage")
        .createFolder(`${userId}/${sessionId}/images`);
      await supabase.storage
        .from("Storage")
        .createFolder(`${userId}/${sessionId}/documents`);
    }

    // Upload the file
    const { error: uploadError } = await supabase.storage
      .from("Storage")
      .upload(filePath, selectedFile);

    if (uploadError) {
      throw uploadError;
    }

    const { data } = supabase.storage.from("Storage").getPublicUrl(filePath);

    if (data) {
      return data.publicUrl;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    return null; // Explicitly return null on failure
  }
};

export const uploadAudioAndGetUrl = async (sessionId, userId, audio) => {
  try {
    const filename = new Date().toISOString().replace(/[-:.]/g, "") + ".mp3";
    const filePath = `${userId}/${sessionId}/audios/${filename}`;

    // Check if the folder exists, if not, create it
    const { data: folderData, error: folderError } = await supabase.storage
      .from("Storage")
      .list(userId);
    await supabase.storage.from("Storage").list(`${userId}/${sessionId}`);

    if (
      folderError &&
      folderError.message.includes("The resource was not found")
    ) {
      await supabase.storage.from("Storage").createFolder(userId);
      await supabase.storage.from("Storage").createFolder(sessionId);
      await supabase.storage
        .from("Storage")
        .createFolder(`${userId}/${sessionId}/audios`);
    }

    // Upload the file
    const { error: uploadError } = await supabase.storage
      .from("Storage")
      .upload(filePath, audio, {
        contentType: "audio/mp3", // Set the content type to MP3
        cacheControl: "3600", // Optional: Set the cache control
        upsert: false, // Optional: Prevent overwriting existing files
      });

    if (uploadError) {
      throw uploadError;
    }

    const { data } = supabase.storage.from("Storage").getPublicUrl(filePath);

    if (data) {
      return data.publicUrl;
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

// ============================================
// Short Chatbot Helper Functions
// ============================================

/**
 * Get active short chatbot session for user and type
 * @param {string} userId - User ID
 * @param {string} type - Type: 'tasks', 'notes', 'lists', 'groceries', or 'reminders'
 * @returns {Promise<{session: object|null, messages: array}>}
 */
export const getShortChatSession = async (userId, type) => {
  try {
    // Check for existing active session
    const { data: session, error: sessionError } = await supabase
      .from("short_chatbot_session")
      .select("*")
      .eq("user_id", userId)
      .eq("type", type)
      .eq("active", true)
      .limit(1)
      .single();

    if (sessionError && sessionError.code !== "PGRST116") {
      // PGRST116 = no rows returned
      console.error("Error fetching short chat session:", sessionError);
      return { session: null, messages: [] };
    }

    if (!session) {
      return { session: null, messages: [] };
    }

    // Load messages for session
    const messages = await getShortChatMessages(session.id);
    return { session, messages };
  } catch (error) {
    console.error("Error in getShortChatSession:", error);
    return { session: null, messages: [] };
  }
};

/**
 * Load messages for a short chatbot session
 * @param {string} sessionId - Session ID
 * @returns {Promise<array>}
 */
export const getShortChatMessages = async (sessionId) => {
  try {
    const { data, error } = await supabase
      .from("short_chatbot_messages")
      .select("*")
      .eq("session_id", sessionId)
      .order("created_at", { ascending: true });

    if (error) {
      console.error("Error loading short chat messages:", error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error("Error in getShortChatMessages:", error);
    return [];
  }
};

/**
 * Clear/deactivate a short chatbot session
 * @param {string} sessionId - Session ID
 * @param {string} userId - User ID
 * @returns {Promise<boolean>}
 */
export const clearShortChatSession = async (sessionId, userId) => {
  try {
    const { error } = await supabase
      .from("short_chatbot_session")
      .update({ active: false })
      .eq("id", sessionId)
      .eq("user_id", userId);

    if (error) {
      console.error("Error clearing short chat session:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error in clearShortChatSession:", error);
    return false;
  }
};

/**
 * Convert short chat messages to display format
 * @param {array} messages - Raw messages from database
 * @returns {array} - Formatted messages for UI display
 */
export const formatShortChatMessages = (messages) => {
  const formatted = [];

  for (const msg of messages) {
    if (msg.user_query) {
      formatted.push({
        role: "user",
        content: msg.user_query,
        id: msg.id,
        created_at: msg.created_at,
      });
    }
    if (msg.response) {
      formatted.push({
        role: "assistant",
        content: msg.response,
        id: msg.id,
        created_at: msg.created_at,
      });
    }
  }

  return formatted;
};


